import React, { useState,useEffect,useRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateShipmentStatus } from "../../store/features/shipmentsSlice";
import { decrementImportsRequiringAttentionThunk } from '../../store/features/dashboardSlice';

const DocModHeader = ({ docId, shipmentId, origin, destination, carrier, trackingNumber }) => {
  const [automationEnabled, setAutomationEnabled] = useState(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null); // Ref for the dropdown
  const dispatch = useDispatch();

  const handleToggleAutomation = () => {
    setAutomationEnabled((prev) => !prev);
  };

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleCloseCase = async () => {
    const confirmClose = window.confirm("Are you sure you want to close this case?");
    if (!confirmClose) return;

    try {
      await dispatch(updateShipmentStatus({ shipmentId, status: "closed" })).unwrap();
      alert("Case closed successfully!");
      dispatch(decrementImportsRequiringAttentionThunk());
    } catch (error) {
      console.error("Failed to close the case:", error);
      alert("Failed to close the case. Please try again.");
    }
  };

  return (
    <div className="mb-2 p-2">
      {/* Header Section */}
      <div className="flex justify-between items-start text-font">
        <div>
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-4 text-font-LIGHT">
            <a href="/dashboard" className="underline hover:text-logo">
              Home
            </a>{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
            <a href={`/dashboard/cases/${shipmentId}`} className="underline hover:text-logo">
              Case #{shipmentId}
            </a>{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
             Processing Document
          </div>


          {/* Case Header */}
          <p>
            <strong>Shipment ID:</strong> {shipmentId}{" "}
            <strong>Origin:</strong> {origin}{" "}
            <strong>Destination:</strong> {destination}{" "}
            <strong>Carrier:</strong> {carrier}{" "}
            <strong>Tracking Number:</strong> {trackingNumber}
          </p>
        </div>

      </div>
    </div>
  );
};

export default DocModHeader;
